module.exports = __webpack_public_path__ + "static/media/ips_home.bb1d4be7.svg";